import {
  getActivityConfig,
  isAnswerOperation,
  isAskUserOperation,
  isConversationComplete,
  isMemoryOperation,
} from "@storytell/streaming";

/**
 * Returns true if the operation should appear in the activity timeline. The open timeline is the
 * turn's whole record, so the user's mid-turn messages and the replies to them belong in it.
 * Excludes: conversation_complete, answer, memory, ask_user, and system operations.
 */
export function isActivityOperation(activity: string | undefined): boolean {
  if (isConversationComplete(activity)) return false;
  if (isAnswerOperation(activity)) return false;
  if (isMemoryOperation(activity)) return false;
  if (isAskUserOperation(activity)) return false;
  const config = getActivityConfig(activity);
  if (config?.isSystemOperation) return false;
  return true;
}
